import styled, { keyframes, css } from "styled-components";
import { FlexRowDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
export const HXMobileLogoContainer = styled(FlexRowDiv) `
    height: 27.2px;
    gap: 8px;
    align-items: center;
    align-self: stretch;
`;
export const HXMobileLogo = styled.img `
    display: block;
    object-fit: contain;
    max-height: 100%;
    max-width: calc(50% - 8.5px);
`;
export const HXMobileHealthExLogo = styled(HXMobileLogo) `
    height: 20px;
`;
export const HXMobileHealthExLogoFullWidth = styled(HXMobileHealthExLogo) `
    max-width: 100%;
`;
export const HXCircularMobileLogoContainer = styled(FlexRowDiv) `
    height: 80px;
    gap: 0px;
    align-items: center;
    justify-content: center;
    align-self: stretch;
`;
export const HXCircularMobileLogo = styled.img `
    display: block;
    object-fit: cover;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    overflow: hidden;
    background-color: ${colors.white_background};
    border-color: ${colors.black_12};
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
`;
export const HXCircularMobileHealthExLogo = styled(HXCircularMobileLogo) `
    background-color: ${colors.navy_main};
`;
export const HXCircularMobileWhiteLogo = styled.img `
    height: 29.33px;
    object-fit: cover;
`;
export const HXCircularMobileHealthExGradientLogo = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88px;
    width: 88px;
    border-radius: 50%;
    border-color: ${colors.black_12};
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
`;
const mergeLogos = keyframes `
    from {
        gap: 20px;
    }
    to {
        gap: 0;
    }
`;
const fadeOut = keyframes `
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;
export const AnimatedLogosContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    align-self: center;
    animation: ${mergeLogos} ${({ animate }) => (animate ? "500ms ease-out 500ms forwards" : "0ms ease-out 0ms forwards")};
`;
const collapseDashedLine = keyframes `
    from {
        opacity: 1;
        max-width: 20.9px;
        margin: 0 -10.45px;
    }
    to {
        opacity: 0;
        max-width: 0;
        margin: 0;
    }
`;
export const AnimatedDashedLineImage = styled.img `
    width: 20.9px;
    height: auto;
    flex-shrink: 0;
    z-index: 0;
    opacity: 1;
    align-self: center;
    margin: 0 -10.45px;
    animation: ${(props) => props.isRecordsFound
    ? css `
                  ${fadeOut} ${props.animate ? "300ms ease-out 700ms forwards" : "0ms ease-out 0ms forwards"}
              `
    : css `
                  ${collapseDashedLine} ${props.animate ? "500ms ease-out 500ms forwards" : "0ms ease-out 0ms forwards"}
              `};
`;
const slideOrgLogoMerge = keyframes `
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(8.8px);
    }
`;
export const AnimatedOrgLogoCircle = styled.div `
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background-color: ${colors.white_main};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 2;
    flex-shrink: 0;
    overflow: hidden;
    ${(props) => props.isRecordsFound
    ? css `
                  animation: ${slideOrgLogoMerge} ${props.animate ? "500ms ease-out 500ms forwards" : "0ms ease-out 0ms forwards"};
              `
    : ""};
`;
export const AnimatedOrgLogoImage = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
const slideHealthExLogoMerge = keyframes `
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-8.8px);
    }
`;
const collapseHealthExLogo = keyframes `
    from {
        opacity: 1;
        max-width: 88px;
    }
    to {
        opacity: 0;
        max-width: 0;
    }
`;
export const AnimatedHealthExLogoCircle = styled.div `
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 1;
    flex-shrink: 0;
    overflow: hidden;
    animation: ${(props) => props.isRecordsFound
    ? css `
                  ${slideHealthExLogoMerge} ${props.animate ? "500ms ease-out 500ms forwards" : "0ms ease-out 0ms forwards"}
              `
    : css `
                  ${collapseHealthExLogo} ${props.animate ? "500ms ease-out 500ms forwards" : "0ms ease-out 0ms forwards"}
              `};
`;
export const AnimatedHealthExLogoImage = styled.img `
    height: 29.33px;
    object-fit: cover;
`;
